var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.962 4.002V3a2 2 0 0 0-4 0v6a2 2 0 0 0 2 2h6a2 2 0 0 0 0-4H9.64c1.789-1.26 3.97-2 6.322-2 6.071 0 11 4.929 11 11s-4.929 11-11 11c-5.786 0-10.535-4.476-10.968-10.152a2 2 0 0 0-3.988.304C1.596 24.893 8.071 31 15.962 31c8.279 0 15-6.721 15-15s-6.721-15-15-15a14.93 14.93 0 0 0-9 3.002z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/restore.183e6a7d5483e05b0d3fdab1a07c4f41.svg";
export { ForwardRef as ReactComponent };